export default __webpack_public_path__ + "static/media/hamburguer-close.bfb2b5fc.svg";